(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/utils.js');
"use strict";


const isServer = typeof exports === 'object';
const youtubeDomain = "https://www.youtube-nocookie.com";
const ytImgDomain = "https://i.ytimg.com/vi";
function loadVideo(options, callback) {
  if (!options) {
    callback('Options object is required');
    return;
  }
  if (!options.type || options.type !== 'youtube') {
    callback('Unsupported media source type');
    return;
  }
  if (!options.videoId) {
    callback('Missing videoId');
    return;
  }
  const {
    videoId,
    height,
    width,
    title,
    type,
    name
  } = options;
  const videoSrc = "".concat(youtubeDomain, "/embed/").concat(videoId, "?rel=0");
  const thumbnailUrl = "".concat(ytImgDomain, "/").concat(videoId);
  const model = {
    name: name || '100',
    type: type || 'youtube',
    src: videoSrc,
    heightPercent: height && width ? height / width * 100 : undefined,
    videoId,
    thumbnailUrl,
    title: title || 'Svenska Spel',
    height: height || '1280',
    width: width || '720'
  };
  callback(null, model);
}
if (isServer) {
  module.exports = {
    loadVideo
  };
} else {
  svs.components.youtube_video.utils = {
    loadVideo
  };
}

 })(window);